import HangMan, { alphabet } from '../../assets/HangMan/HangMan'
import * as actionTypes from '../actions/actionTypes'

const initialPuzzle = 'some dummy data'
const initialStatusMessage = 'Type or click on any letter to make a guess'
const numberOfGuesses = 5
const game = new HangMan(initialPuzzle, numberOfGuesses)

const initialState = {
  game,
  numberOfGuesses,
  puzzleWordCount: 3,
  alphabet,
  puzzle: initialPuzzle,
  typedLetterIndex: null,
  clickedLetter: false,
  correctGuess: false,
  correctGuessesCount: 0,
  incorrectGuessesCount: 0,
  statusMessage: initialStatusMessage,
  currentLetter: '',
  currentNumberOfCorrectLetters: null,
  gamesPlayed: []
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PUZZLE:
      return {
        ...state,
        game,
        puzzle: game.puzzle
      }
    case actionTypes.KEY_PRESS:
      return {
        ...state,
        clickedLetterIndex: action.letterIndex
      }
    case actionTypes.UPDATE_ALPHABET:
      const updatedAlphabet = [...state.alphabet]
      updatedAlphabet[action.clickedLetterIndex].clickedLetter = true
      updatedAlphabet[action.clickedLetterIndex].correctGuess = game.isCorrectGuess(updatedAlphabet[action.clickedLetterIndex].letter) ? true : false
      
      const updatedCorrectGuessesCount = updatedAlphabet.filter(letter => letter.correctGuess).length
      const updatedIncorrectGuessesCount = updatedAlphabet.filter(letter => letter.correctGuess === false).length
      
      return {
        ...state,
        alphabet: updatedAlphabet,
        correctGuessesCount: updatedCorrectGuessesCount,
        incorrectGuessesCount: updatedIncorrectGuessesCount
      }
    case actionTypes.UPDATE_STATUS_MESSAGE:
      return {
        ...state,
        statusMessage: state.game.statusMessage
      }
    case actionTypes.SET_CURRENT_LETTER:
      return {
        ...state,
        currentLetter: action.letter
      }
    case actionTypes.SET_CURRENT_NUMBER_OF_CORRECT_LETTERS:
      return {
        ...state,
        currentNumberOfCorrectLetters: action.currentNumberOfCorrectLetters
      }
    default:
      return state
  }
}

export default reducer